
import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
    {
      question: "Qu'est-ce qu'un contrat de mariage ?",
      answer:
        "Le contrat de mariage est un acte notarié signé avant le mariage qui permet aux futurs époux de choisir leur régime matrimonial.\n\nIl définit les règles de gestion, de propriété et de partage des biens du couple, pendant le mariage et en cas de séparation ou de décès.",
    },
    {
      question: "Est-il obligatoire de faire un contrat de mariage ?",
      answer:
        "Non, le contrat de mariage n’est pas obligatoire.\n\nSi les époux ne signent aucun contrat, ils seront automatiquement soumis au régime légal : la communauté réduite aux acquêts.\n\nUn contrat devient utile si vous souhaitez organiser différemment la gestion ou la séparation des biens.",
    },
    {
      question: "Quels sont les principaux types de contrats de mariage ?",
      answer:
        "Il existe plusieurs types de contrats :\n\n• La séparation de biens : chaque époux reste propriétaire de ses biens, présents et futurs.\n• La communauté universelle : tous les biens deviennent communs, présents et futurs.\n• La participation aux acquêts : séparation de biens durant le mariage, mais partage des gains en cas de dissolution.\n• La communauté réduite aux acquêts avec aménagements : possibilité d’y ajouter des clauses spécifiques.",
    },
    {
      question: "Quel est le coût d’un contrat de mariage ?",
      answer:
        "Le tarif dépend de la complexité du contrat et des éventuels apports intégrés.\n\nEn moyenne :\n• Contrat simple : entre 350 € et 500 € TTC.\n• Avec apports importants : les frais proportionnels s’ajoutent selon un barème dégressif (environ 400 € à 1000 € en fonction des montants).\n\nDes frais de débours et la TVA viennent également s’ajouter.",
    },
    {
      question: "Peut-on faire un contrat de mariage après le mariage ?",
      answer:
        "Oui, il est possible de modifier ou mettre en place un contrat de mariage après le mariage.\n\nCette démarche nécessite un acte notarié et une homologation par un juge si le couple a des enfants mineurs ou majeurs protégés.\n\nUn délai de 2 ans de mariage est exigé avant toute modification.",
    },
    {
      question: "Un contrat de mariage protège-t-il les biens personnels ?",
      answer:
        "Oui, notamment dans le cadre d’une séparation de biens.\n\nLes biens acquis avant le mariage ainsi que ceux reçus par donation ou héritage restent la propriété personnelle de chaque époux.\n\nCela protège également les patrimoines personnels en cas de dettes contractées par l’autre époux.",
    },
    {
      question: "Le contrat de mariage est-il valable à l’international ?",
      answer:
        "Un contrat de mariage rédigé en France est juridiquement valable sur le territoire français.\n\nÀ l’étranger, la reconnaissance dépend de la législation locale.\n\nPour les couples binationaux ou vivant à l’international, il est recommandé d’établir un contrat avec une clause de loi applicable et de vérifier les règles du pays de résidence.",
    },
    {
      question: "Peut-on inclure des clauses spécifiques dans un contrat de mariage ?",
      answer:
        "Oui, il est possible d'ajouter des clauses personnalisées.\n\nExemples :\n• Clause de préciput : pour attribuer certains biens à l’un des époux en cas de décès.\n• Clause d’exclusion de certains biens de la communauté.\n• Donations ou avantages matrimoniaux.\n\nUn notaire vous aidera à adapter ces clauses à votre situation.",
    },
    {
      question: "Comment choisir le bon régime matrimonial ?",
      answer:
        "Le choix dépend de plusieurs facteurs :\n• La situation patrimoniale des époux.\n• La présence d’enfants issus d’une précédente union.\n• Les risques professionnels ou patrimoniaux.\n• Le souhait de protéger son conjoint en cas de décès.\n\nUn rendez-vous avec un notaire est conseillé pour bien comprendre les implications de chaque régime.",
    },
    {
      question: "Que se passe-t-il en cas de divorce avec un contrat de mariage ?",
      answer:
        "Le contrat de mariage détermine les règles de partage des biens en cas de divorce.\n\n• En séparation de biens : chacun récupère ses biens personnels.\n• En communauté : les biens communs sont partagés à parts égales.\n\nLe contrat peut également contenir des clauses visant à protéger l’un des époux ou à faciliter la séparation.",
    },
  ];

function Faq() {
  return (
    <section className="mt-10">
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6  lg:px-8 ">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Questions les plus fréquentes au sujet du contrat de mariage
          </h2>
          <dl className="mt-16 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                    <span className="text-base/7 font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <PlusSmallIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                      <MinusSmallIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12">
                  <p className="text-base/7 text-gray-600">{faq.answer}</p>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </section>
  );
}

export default Faq;
